import axios from 'axios'

const brokerage_company_register_form = {
  namespaced: true,
  state() {
    return {
      data: {
        email: null,
        uuid: null,
        company_name: null,
        company_name_kana: null,
        licence_type: null,
        licence_number: null,
        postal_code: null,
        prefecture_code: null,
        address1: null,
        address2: null,
        tel: null,
        fax: null,
        name: null,
        name_kana: null,
        password: null,
        contact: null,
        office: null,
        department: null,
        management_company_code: null,
        use_two_step_authentication: false,
      },
      errors: {},
      isLoadErrorConflict: false,
      isLoadErrorGone: false,
    }
  },

  getters: {
    parameters(state) {
      return state.data;
    },
  },

  mutations: {
    setData(state, data) {
      state.data.email = data.email;
      state.data.management_company_code = data.management_company_code;
      state.errors = {};
    },
    setUuid(state, uuid) {
      state.data.uuid = uuid
    },
    setLoadError(state, payload) {
      state.isLoadErrorConflict = (payload.status === 409);
      state.isLoadErrorGone = (payload.status === 410);
    },
    setErrors(state, errors) {
      state.errors = {...errors}
    },
    resetData(state) {
      state.data.email = null;
      state.data.management_company_code = null;
    },
    clearError(state) {
      state.errors = {}
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    load({commit}, {uuid}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/brokerage_companies/provisional', {params: {uuid: uuid}}).then((response) => {
          commit('setData', response.data.data);
          commit('setUuid', uuid)
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if ([409, 410].includes(error.response.status)) {
            commit('setLoadError', {status: error.response.status});
            handled = true;
          }
          reject({handled});
        });
      });
    },

    register({getters, commit}) {
      return new Promise((resolve, reject) => {
        commit('clearError')
        axios.post('/api/brokerage_companies', getters.parameters).then(() => {
          commit('setFlashMessage', {value: '登録しました'}, {root: true});
          commit('resetData')
          commit('clearError')
          resolve(true)
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    }
  }
}

export default brokerage_company_register_form;
